import React from "react";

export default function ProficiencyLevels_KH() {
  return (
    <>
      <h2>ការបរិយាយពីកម្រិតជំនាញប្រើប្រាស់ឌីជីថល</h2>
      <div>
        ដើម្បីយល់កាន់តែច្បាស់ពីកម្រិតសមត្ថភាពឌីជីថល អ្នកអាចមើលទៅរង្វង់បង្ហាញសមត្ថភាពតាមផ្នែក។
        វាអាចជួយឱ្យអ្នកដឹងពីភាពខ្លាំង និងភាពខ្សោយ ហើយផ្តល់ជាគំនិត
        និងគន្លឹះដើម្បីអភិវឌ្ឍសមត្ថភាពប្រើប្រាស់ឌីជីថលរបស់អ្នកក្នុងអាជីពការងារជាក់ស្តែង។
        <ul>
          <li>កម្រិត A ៖ ពិន្ទុ 0 បើគិតជាភាគរយ 0%</li>
          <li>កម្រិត B ៖ ពិន្ទុចន្លោះពី 0-32 បើគិតជាភាគរយពី 0-33%</li>
          <li>កម្រិត C ៖ ពិន្ទុចន្លោះពី 33-64 បើគិតជាភាគរយពី 34%-67%</li>
          <li>កម្រិត D ៖ ពិន្ទុចន្លោះពី 65-96 បើគិតជាភាគរយពី 68%-100%</li>
        </ul>
      </div>
      <div>
        <h3>កម្រិត A ៖ អ្នកទើបចាប់ផ្តើមប្រើប្រាស់</h3>
        <div style={{ marginBottom: "20px" }}>
          អ្នកកំពុងស្ថិតនៅត្រង់ចំណុចចាប់ផ្តើមនៃការប្រើប្រាស់បច្ចេកវិទ្យាឌីជីថលសម្រាប់ការអប់រំ។ មានឧបករណ៍
          និងបច្ចេកទេសឌីជីថលជាច្រើនដែលអ្នកមិនធ្លាប់បានស្គាល់ និងប្រើប្រាស់ពីមុនមក។ អាស្រ័យដូចនេះហើយ
          អ្នកអាចនឹងមានចិត្តចង់ចេះចង់ដឹង និងឆន្ទៈក្នុងការសិក្សាពីបច្ចេកវិទ្យាទាំងអស់នោះ។
          ដោយប្រើប្រាស់ធនធានឌីជីថល និងការគាំទ្រដែលត្រឹមត្រូវ អ្នកនឹងរកឃើញឆាប់ៗនូវវិធីក្នុងការអនុវត្ត
          និងសិក្សាបច្ចេកវិទ្យាឌីជីថលថ្មីៗ ដើម្បីជួយបង្កើនប្រសិទ្ធភាពនៃការបង្រៀនរបស់អ្នក។
        </div>
      </div>
      <div>
        <h3>កម្រិត B ៖ អ្នកប្រើប្រាស់ឌីជីថលថ្មីថ្មោង</h3>
        <div style={{ marginBottom: "20px" }}>
          អ្នកប្រហែលបានសាកល្បងប្រើប្រាស់ឧបករណ៍ឌីជីថលមួយចំនួន
          ហើយអ្នកក៏កំពុងគិតពីវិធីប្រើប្រាស់វាឱ្យកាន់តែមានប្រសិទ្ធភាព។
          នៅពេលស្វែងយល់ពីឧបករណ៍ទាំងនេះកាន់តែស៊ីជម្រៅ
          អ្នកនឹងដឹងថាឧបករណ៍ទាំងនេះបានជួយច្រើនលើវិធីសាស្រ្តបង្រៀនរបស់អ្នក ហើយអ្នកពិតជាចង់ស្វែងរក
          និងប្រើប្រាស់ឧបករណ៍ឌីជីថលថ្មីៗបន្ថែមទៀត ដើម្បីឆ្លើយតបនឹងបរិបទសិក្សាដទៃៗទៀត។
        </div>
      </div>
      <div>
        <h3>កម្រិត C ៖ អ្នកអនុវត្តឌីជីថលជាប្រចាំ</h3>
        <div style={{ marginBottom: "20px" }}>
          អ្នកបានឆ្លងផុតកម្រិតមូលដ្ឋាន
          ហើយបានប្រើប្រាស់ឧបករណ៍ឌីជីថលទាំងនោះក្នុងការបង្រៀនប្រចាំថ្ងៃរបស់អ្នក។
          អ្នកស្គាល់ឧបករណ៍ឌីជីថលកាន់តែច្រើន
          និងចេះជ្រើសរើសឧបករណ៍សមស្របណាមួយប្រើប្រាស់តម្រូវតាមស្ថានភាពជាក់ស្តែង។
          អ្នកបានមើលឃើញទាំងគុណសម្បត្តិ និងគុណវិបត្តិនៃឧបករណ៍ឌីជីថលទាំងនោះ។ តាមរយៈការប្រើប្រាស់
          និងឆ្លុះបញ្ចាំងជាប្រចាំ អ្នកនឹងកែលម្អវិធីសាស្រ្តក្នុងការប្រើប្រាស់ឧបករណ៍ទាំងអស់នោះ
          ឱ្យកាន់តែមានប្រសិទ្ធភាព។ ហើយនៅពេលជំនាញប្រើប្រាស់របស់អ្នកកើនឡើង អ្នកអាចនឹងចែករំលែក
          និងណែនាំពីវិធីប្រើប្រាស់ទៅមិត្តរួមការងារក្នុងកន្លែងធ្វើការ។
        </div>
      </div>
      <div>
        <h3>កម្រិត D ៖ អ្នកនវានុវត្តន៍ឌីជីថល</h3>
        <div style={{ marginBottom: "20px" }}>
          អ្នកកំពុងស្ថិតនៅទីតាំងក្លាយជាអ្នកនវានុវត្តន៍អប់រំក្នុងការប្រើប្រាស់បច្ចេកវិទ្យាឌីជីថល។
          សមត្ថភាពក្នុងការប្រើប្រាស់បច្ចេកវិទ្យាឌីជីថលរបស់អ្នក កាន់តែច្រើន និងមានភាពច្បាស់លាស់
          ដែលធ្វើឱ្យអ្នកអាចជ្រើសរើសឧបករណ៍ឌីជីថលណាមួយមកប្រើប្រាស់កាន់តែមានប្រសិទ្ធភាពជាងមុន។
          អ្នកមិនគ្រាន់តែជាអ្នកប្រើប្រាស់ប៉ុននោះទេ ឥឡូវនេះអ្នកក្លាយជាអ្នកដឹកនាំ ដែលជ្រើសរើស
          និងជួយក្រុមការងារប្រើប្រាស់ឧបករណ៍ឌីជីថលផ្សេងៗជំនួយក្នុងការបង្រៀនសម្រាប់ស្ថាប័នរបស់អ្នក។
          អ្នកនៅតែបន្តអភិវឌ្ឍខ្លួនឯង ហើយប្រើប្រាស់បច្ចេកវិទ្យាឌីជីថលថ្មីៗ
          និងមានគំនិតនវានុវត្តន៍កាន់តែល្អឡើងៗ។ ពេលអ្នកក្លាយជាមនុស្សគំរូនៃការប្រើប្រាស់ឌីជីថលក្នុងសហគមន៍
          អ្នកនៅតែបន្តបើកចិត្តទទួលគំនិតថ្មីៗ និងត្រៀមខ្លួនជាស្រេចសម្រាប់នវានុវត្តន៍ឌីជីថលថ្មីៗទៀត។
        </div>
      </div>
    </>
  );
}
